import { FixedCommentType, FixedCommentSessionType } from "../../misc/api/FixedComments/apiTypes";
import { forEach, map } from "lodash";
import { FixedCommentEntityTypeEnum } from "../../misc/api/FixedComments/FixedCommentSetEntityTypes";
import { StudyFixedCommentSet, FixedComment, FixedCommentSet } from "webportalclient";


export interface FixedCommentEntries {
    [key: string]: FixedComment
}

export interface FixedCommentSetFormModel {
    Id: string;
    EntityType: string;
    SessionType: string;
    SetType: string;
    Comments: FixedCommentEntries
    DefaultSelectedComment: string;
}

export interface InternalFormState extends FixedCommentSetFormModel {
    resetComments: number;
}

export function GetFormStateFromModel(model: StudyFixedCommentSet): FixedCommentSetFormModel {
    let comments = {};

    forEach(model.fixedCommentSets[0].comments, c => comments[c.id] = c);

    return {
        Id: model.id,
        SessionType: model.sessionType,
        SetType: model.commentSetType,
        EntityType: model.fixedCommentSets[0].entityType,
        DefaultSelectedComment: model.fixedCommentSets[0]?.defaultComment?.comment,
        Comments: comments
    };
}

export function GetSetFormStateFromModel(model: FixedCommentSet): FixedCommentSetFormModel {
    let comments = {};

    forEach(model.comments, c => comments[c.id] = c);

    return {
        Id: model.id,
        SessionType: model.studySet.sessionType,
        SetType: model.studySet.commentSetType,
        EntityType: model.entityType,
        DefaultSelectedComment: model.defaultComment?.comment,
        Comments: comments
    };
}

export function GetModelFromFormState(formState: FixedCommentSetFormModel, studyId: string): StudyFixedCommentSet {

    let comments: FixedComment[] = map(formState.Comments, (c, id) => {
        return {
            id: id,
            ...c,
        };
    });

    return {
        id: formState.Id,
        studyId: studyId,
        sessionType: formState.SessionType,
        commentSetType: formState.SetType,
        fixedCommentSets: [{
            studySetId: formState.Id,
            entityType: formState.EntityType,
            comments: comments
        }]
    };
}
